import { render, staticRenderFns } from "./Integrations.vue?vue&type=template&id=8fbeae0e&scoped=true&"
import script from "./Integrations.vue?vue&type=script&lang=js&"
export * from "./Integrations.vue?vue&type=script&lang=js&"
import style0 from "./Integrations.vue?vue&type=style&index=0&id=8fbeae0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbeae0e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Integrations.vue
// module id = null
// module chunks = 